import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
export function FormsVideosPage() {
  const videos = [{
    url: 'https://www.youtube.com/watch?v=lhr9mGgmpY0',
    instructor: 'Mark Kanaar',
    title: 'Kee Cho Hyung Il Boo White Belt Requirement Basic Form 1',
    description: 'Master Mark S. Kanaar demonstrates Kee Cho Hyung Il Boo Basic Form 1, the white belt requirement for Che Ko Taekwondo Academy.'
  }, {
    url: 'https://www.youtube.com/watch?v=dZCSAOdi_cs',
    instructor: 'Mark Kanaar',
    title: 'Explanation of Kee Cho Hyung Ee Boo Basic Form 2 – Front View',
    description: 'Master Mark S. Kanaar explains Kee Cho Hyung Ee Boo Basic Form 2, the white belt form with yellow stripe requirement at Che Ko Taekwondo Academy.'
  }, {
    url: 'https://www.youtube.com/watch?v=gYoYC_TPwlY',
    instructor: 'Mark Kanaar',
    title: 'Break Down for Kee Cho Hyung Sam Boo for AAU Taekwondo Athletes',
    description: 'Master Mark S. Kanaar breaks down Kee Cho Hyung Sam Boo Basic Form 3, focusing on philosophical meaning and AAU competition requirements.'
  }, {
    url: 'https://www.youtube.com/watch?v=bmJDfyTTQa8',
    instructor: 'Mark Kanaar',
    title: 'Break Down and Explanation of Tae Guek Il Jang – Yellow Belt Requirement',
    description: 'Tae Guek Il Jang First Form of the Universe. Philosophical meaning: creation and beginning. Yellow belt requirement.'
  }, {
    url: 'https://www.youtube.com/watch?v=HwQgIiH94Ho',
    instructor: 'Mark Kanaar',
    title: 'Break Down and Explanation of Tae Guek Ee Jang – Green Stripe Requirement',
    description: 'Tae Guek Ee Jang Second Form of the Universe. Philosophical meaning: joyfulness. Yellow belt with green stripe requirement.'
  }, {
    url: 'https://www.youtube.com/watch?v=YvdUUCa2n-8',
    instructor: 'Mark Kanaar',
    title: 'Break Down and Explanation of Tae Guek Sam Jang – Green Belt Requirement',
    description: 'Tae Guek Sam Jang Third Form of the Universe. Philosophical meaning: fire. Green belt requirement.'
  }, {
    url: 'https://www.youtube.com/watch?v=IHbu8FDzhgo',
    instructor: 'Mark Kanaar',
    title: 'Break Down and Explanation of Tae Guek Sa Jang – Blue Stripe Requirement',
    description: 'Tae Guek Sa Jang Fourth Form of the Universe. Philosophical meaning: thunder. Green belt with blue stripe requirement.'
  }, {
    url: 'https://www.youtube.com/watch?v=55mrOsz7mnQ',
    instructor: 'Mark Kanaar',
    title: 'Break Down and Explanation of Tae Guek Oh Jang – Blue Belt Requirement',
    description: 'Tae Guek Oh Jang Fifth Form of the Universe. Philosophical meaning: wind. Blue belt requirement.'
  }, {
    url: 'https://www.youtube.com/watch?v=tK60QmbLbkU',
    instructor: 'Mark Kanaar',
    title: 'Break Down and Explanation of Tae Guek Yuk Jang – Red Stripe Requirement',
    description: 'Tae Guek Yuk Jang Sixth Form of the Universe. Philosophical meaning: water. Blue belt with red stripe requirement.'
  }, {
    url: 'https://www.youtube.com/watch?v=QhxCXfplIHs',
    instructor: 'Mark Kanaar',
    title: 'Break Down and Explanation of Tae Guek Chil Jang – Red Belt Requirement',
    description: 'Tae Guek Chil Jang Seventh Form of the Universe. Philosophical meaning: mountain. Red belt requirement.'
  }, {
    url: 'https://www.youtube.com/watch?v=ojaJ629ubRs',
    instructor: 'Mark Kanaar',
    title: 'Break Down and Explanation of Tae Guek Pal Jang – Red Belt with Black Stripe',
    description: 'Tae Guek Pal Jang Eighth Form of the Universe. Philosophical meaning: earth. Red belt with black stripe requirement.'
  }, {
    url: 'https://www.youtube.com/watch?v=mYuVkkL8eiM',
    instructor: 'Mark Kanaar',
    title: 'Break Down for Palgwe Il Jang for AAU Taekwondo Athletes',
    description: 'Palgwe Il Jang First Form of the Korean Trigram. Philosophical meaning: creation and beginning. AAU requirement.'
  }, {
    url: 'https://www.youtube.com/watch?v=Eeyxfw7bmww',
    instructor: 'Mark Kanaar',
    title: 'Break Down of Palgwe Sa Jang for AAU Taekwondo Competition',
    description: 'Palgwe Sa Jang Fourth Form of the Korean Trigram. Philosophical meaning: thunder. AAU intermediate requirement.'
  }, {
    url: 'https://www.youtube.com/watch?v=UPoTz95IMqE',
    instructor: 'Mark Kanaar',
    title: 'Break Down of Palgwe Sam Jang for AAU Taekwondo Competition',
    description: 'Palgwe Sam Jang Third Form of the Korean Trigram. Philosophical meaning: fire. AAU intermediate requirement.'
  }, {
    url: 'https://www.youtube.com/watch?v=kiN9Q1fJMZo',
    instructor: 'Mark Kanaar',
    title: 'Break Down for Pyung Ahn Cho Dan – AAU Novice Form',
    description: 'Pyung Ahn Cho Dan from the Moo Duk Kwan Novice Division. First step of serenity for AAU athletes.'
  }, {
    url: 'https://www.youtube.com/watch?v=TxdWCSaty0o',
    instructor: 'Mark Kanaar',
    title: 'Break Down of Chon-Ji for AAU Taekwondo Athletes',
    description: 'Chon-Ji form representing heaven and earth. AAU novice and intermediate division requirement.'
  }, {
    url: 'https://www.youtube.com/watch?v=4BtTwqXpx-A',
    instructor: 'Mark Kanaar',
    title: 'A Run Through of Bo Form One for Beginner Staffers',
    description: 'Bo Form One demonstration for beginner students learning traditional weapons staff forms.'
  }, {
    url: 'https://www.youtube.com/watch?v=0529N1TgKA4',
    instructor: 'Mark Kanaar',
    title: 'Break Down for Palgwe Ee Jang for AAU Taekwondo Athletes',
    description: 'Palgwe Ee Jang Second Form of the Korean Trigram. Philosophical meaning: joyfulness. AAU requirement.'
  }];
  const getYouTubeEmbedUrl = (url: string) => {
    const videoId = url.split('v=')[1];
    return `https://www.youtube.com/embed/${videoId}`;
  };
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-868">
      <Header data-id="element-869" />

      <main className="pt-20" data-id="element-870">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-slate-900 to-slate-800 text-white py-20" data-id="element-871">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-872">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-873">
              Taekwondo Forms & Training Videos
            </h1>
            <p className="text-lg text-slate-200 max-w-3xl" data-id="element-874">
              This page contains official Che Ko Martial Arts Taekwondo form
              requirements and breakdown videos, taught by Master Mark S.
              Kanaar. These videos support students and parents by clearly
              demonstrating required forms, belt progression expectations, and
              competition-specific standards.
            </p>
          </div>
        </section>

        {/* Video Grid Section */}
        <section className="py-16 bg-white" data-id="element-875">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-876">
            <div className="grid md:grid-cols-2 gap-8" data-id="element-877">
              {videos.map((video, index) => <div key={index} className="bg-white border border-slate-200 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-878">
                  {/* Video Embed */}
                  <div className="aspect-video" data-id="element-879">
                    <iframe src={getYouTubeEmbedUrl(video.url)} title={video.title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full" data-id="element-880"></iframe>
                  </div>

                  {/* Video Info */}
                  <div className="p-6" data-id="element-881">
                    <p className="text-sm text-slate-500 mb-2" data-id="element-882">
                      Instructor: {video.instructor}
                    </p>
                    <h3 className="text-xl font-bold text-[#1a2332] mb-3" data-id="element-883">
                      {video.title}
                    </h3>
                    <p className="text-slate-600 leading-relaxed" data-id="element-884">
                      {video.description}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-br from-[#dc2626] to-[#b91c1c] text-white" data-id="element-885">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-886">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-887">
              Train with Confidence. Progress with Purpose.
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto" data-id="element-888">
              These forms represent the structured path students follow as they
              advance through Che Ko Martial Arts. If you are new, your first
              two weeks are free and include full access to beginner classes and
              guidance from experienced instructors.
            </p>
            <Button variant="secondary" size="lg" className="text-lg shadow-xl" data-id="element-889">
              Get 2 Weeks Free
            </Button>
          </div>
        </section>
      </main>

      <Footer data-id="element-890" />
    </div>;
}